import React, { useState, useEffect } from 'react';
import styles from './ReportsPage.module.scss';
import { useNavigate } from 'react-router-dom';
import reportService, { CustomerReportRow, OverallReportRow, GstReportRow, EmployeeReportRow, RevenueReportRow, BalanceTransactionRow } from '../../services/reportService';
import customerService from '../../services/customerService';
import accountHeadService from '../../services/accountHeadService';
import employeeService from '../../services/employeeService';
import settingsService from '../../services/settingsService';
import { Employee } from '../../types/employeeTypes';
import { formatDateDMY, formatDateTimeDMY } from '../../utils/helpers';
import { useAuth } from '../../hooks/useAuth';
import InactiveCompanyActionRestriction from '../../components/InactiveCompanyActionRestriction';
import invoiceService from '../../services/invoiceService';
import { toast } from 'react-toastify';
import { Invoice } from '../../types/invoiceTypes';
import receivedAmountService from '../../services/receivedAmountService';

const REPORTS = [
  { key: 'customer', label: 'Customer Report' },
  { key: 'overall', label: 'Overall Report' },
  { key: 'gst', label: 'GST Report' },
  { key: 'employee', label: 'Employee Report' },
  { key: 'revenue', label: 'Revenue Report' },
  { key: 'balance', label: 'Balance Report' },
];


const ReportsPage: React.FC = () => {

  const today = new Date().toLocaleDateString('en-CA').slice(0, 10);

  console.log("today:::::::;", today)
  const [activeReport, setActiveReport] = useState('customer');
  const [customerData, setCustomerData] = useState<CustomerReportRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [customerSearch, setCustomerSearch] = useState('');
  const [receivedAmounts, setReceivedAmounts] = useState<any[]>([]);
  const navigate = useNavigate();

  // Overall report state
  const [overallData, setOverallData] = useState<OverallReportRow[]>([]);
  const [overallLoading, setOverallLoading] = useState(false);
  const [overallError, setOverallError] = useState<string | null>(null);
  const [customerOptions, setCustomerOptions] = useState<{ id: string, name: string }[]>([]);
  const [accountHeadOptions, setAccountHeadOptions] = useState<{ id: string, name: string }[]>([]);
  const [filters, setFilters] = useState({
    customer_id: '', // instead of 'all'
    account_head_id: '', // instead of 'all'
    from_date: today,
    to_date: today,
  });
  const [pendingFilters, setPendingFilters] = useState(filters);
  const [printType, setPrintType] = useState<'both' | 'received' | 'invoice'>('both');
  const [printMode, setPrintMode] = useState<'accountHead' | 'overall'>('accountHead');

  // GST report state
  const [gstData, setGstData] = useState<GstReportRow[]>([]);
  const [gstLoading, setGstLoading] = useState(false);
  const [gstError, setGstError] = useState<string | null>(null);
  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  const defaultFromDate = firstDay.toLocaleDateString('en-CA');
  const defaultToDate = lastDay.toLocaleDateString('en-CA');
  const [invoices, setInvoices] = useState<Invoice[]>([]);

  const [gstFilters, setGstFilters] = useState({
    account_head_id: '',
    from_date: defaultFromDate,
    to_date: defaultToDate,
  });
  const [gstPendingFilters, setGstPendingFilters] = useState(gstFilters);
  // const [gstAccountHeadOptions, setGstAccountHeadOptions] = useState<{ id: string, name: string }[]>([]);

  // Employee report state
  const [employeeData, setEmployeeData] = useState<EmployeeReportRow[]>([]);
  const [employeeLoading, setEmployeeLoading] = useState(false);
  const [employeeError, setEmployeeError] = useState<string | null>(null);
  const [employeeOptions, setEmployeeOptions] = useState<{ id: string, name: string }[]>([]);
  const [employeeFilters, setEmployeeFilters] = useState({
    employee_id: '', // instead of 'all'
    from_date: today,
    to_date: today,
  });
  const [pendingEmployeeFilters, setPendingEmployeeFilters] = useState(employeeFilters);

  // Revenue report state
  const [revenueData, setRevenueData] = useState<RevenueReportRow[]>([]);
  const [revenueLoading, setRevenueLoading] = useState(false);
  const [revenueError, setRevenueError] = useState<string | null>(null);
  const [revenueFilters, setRevenueFilters] = useState({
    account_head_id: '', // instead of 'all'
    from_date: today,
    to_date: today,
  });
  const [pendingRevenueFilters, setPendingRevenueFilters] = useState(revenueFilters);

  const [companyInfo, setCompanyInfo] = useState({ name: 'Invoice Management', address: '' });

  const { auth } = useAuth();

  useEffect(() => {
    if (activeReport === 'customer') {
      setLoading(true);
      setError(null);
      reportService.getCustomerReport()
        .then(data => setCustomerData(data))
        .catch(() => setError('Failed to load customer report'))
        .finally(() => setLoading(false));
    }
  }, [activeReport]);

  // Fetch filter options on mount
  useEffect(() => {
    customerService.getCustomers().then(data => setCustomerOptions([{ id: 'all', name: 'All' }, ...data.map((c: any) => ({ id: c.id, name: c.name }))]));
    accountHeadService.getAccountHeads().then(data => setAccountHeadOptions([{ id: 'all', name: 'All' }, ...data.map((a: any) => ({ id: a.id, name: a.name }))]));
    employeeService.getEmployees().then(response => {
      console.log("response1234:::::::::", response);
      const normalizedEmployees = Array.isArray(response)
        ? response
            .map(emp => ({
              id: emp.id || '',
              name: emp.name || '',
            }))
            .filter((emp): emp is Employee => emp !== null)
        : [];
      setEmployeeOptions([{ id: 'all', name: 'All Employees' }, ...normalizedEmployees]);
    });
  }, []);

  useEffect(() => {
    settingsService.getCompanyInfo().then(data => {
      console.log("aaaaaa:::::::", data.name);
      setCompanyInfo({
        name: data.name,
        address: data.address,
      });
    });
  }, []);

  // Fetch overall report data when filters are applied
  useEffect(() => {
    if (activeReport === 'overall') {
      setOverallLoading(true);
      setOverallError(null);
      reportService.getOverallReport(filters)
        .then(data => setOverallData(data))
        .catch(() => setOverallError('Failed to load overall report'))
        .finally(() => setOverallLoading(false));
    }
  }, [activeReport, filters]);


  // Fetch GST report data when filters are applied
  useEffect(() => {
    if (activeReport === 'gst') {
      setGstLoading(true);
      setGstError(null);
      reportService.getGstReport(gstFilters)
        .then(data => setGstData(data))
        .catch(() => setGstError('Failed to load GST report'))
        .finally(() => setGstLoading(false));
    }
  }, [activeReport, gstFilters]);


  // Fetch employee report data when filters are applied
  useEffect(() => {
    if (activeReport === 'employee') {
      setEmployeeLoading(true);
      setEmployeeError(null);
      reportService.fetchEmployeeReport(employeeFilters)
        .then(data => setEmployeeData(data))
        .catch(() => setEmployeeError('Failed to load employee report'))
        .finally(() => setEmployeeLoading(false));
    }
  }, [activeReport, employeeFilters]);

  // Fetch revenue data when filters are applied
  useEffect(() => {
    if (activeReport === 'revenue') {
      setRevenueLoading(true);
      setRevenueError(null);
      reportService.getRevenueReport(revenueFilters)
        .then(data => setRevenueData(data))
        .catch(() => setRevenueError('Failed to load revenue report'))
        .finally(() => setRevenueLoading(false));
    }
  }, [activeReport, revenueFilters]);

  const loadInvoices = async (id: string) => {
    if (!id) return [];
    try {
      const invoicesData = await invoiceService.getInvoicesByCustomer(id);
      setInvoices(Array.isArray(invoicesData) ? invoicesData : []);
      return Array.isArray(invoicesData) ? invoicesData : [];
    } catch (error) {
      console.error('Failed to load invoices:', error);
      toast.error('Failed to load customer invoices');
      setInvoices([]);
      return [];
    } 
  };
  
  const loadReceivedAmounts = async (id: string) => {
    if (!id) return [];
    try {
      const allReceivedAmounts = await receivedAmountService.getAll();
      const customerReceivedAmounts = allReceivedAmounts.filter(
        received => String(received.customer_id) === String(id)
      );
      setReceivedAmounts(customerReceivedAmounts);
      return customerReceivedAmounts;
    } catch (error) {
      console.error('Failed to load received amounts:', error);
      toast.error('Failed to load customer received amounts');
      setReceivedAmounts([]);
      return [];
    }
  };

  const getPrintContent = async() => {
    const now = new Date();
    const printDate = now.toLocaleDateString();
    const printTime = now.toLocaleTimeString();
    const customerName =
      filters.customer_id && filters.customer_id !== 'all'
        ? (customerOptions.find(c => String(c.id) === String(filters.customer_id))?.name || 'Customer')
        : 'All Customers';
    const accountHeadName =
      filters.account_head_id && filters.account_head_id !== 'all'
        ? (accountHeadOptions.find(a => String(a.id) === String(filters.account_head_id))?.name || 'Account Head')
        : 'All Account Heads';
    const dateRange = `From ${filters.from_date} To ${filters.to_date}`;

    let totalBalanceAmount = 0;

    if (filters.customer_id !== 'all') {
      const invoicesData = await loadInvoices(filters.customer_id);
      const receivedData = await loadReceivedAmounts(filters.customer_id);

      const totalInvoiceAmount = invoicesData.reduce(
        (sum, inv) => sum + (Number(inv.total_amount) || 0),
        0
      );

      const totalReceivedAmount = receivedData.reduce(
        (sum, received) => sum + (Number(received.amount) || 0),
        0
      );

      totalBalanceAmount = totalInvoiceAmount - totalReceivedAmount;
      console.log("totalBalanceAmount::::::", totalBalanceAmount);
    }
    
    // Calculate totals based on filtered data and print type
    let totalInvoice = 0;
    let totalReceived = 0;

    if (printType === 'invoice') {
      // Only calculate invoice totals for invoice-only print
      totalInvoice = filteredOverallData
        .filter(row => row.type === 'Invoice')
        .reduce((sum, row) => {
          const amount = printMode === 'overall' ? (Number(row.total_amount) || 0) : (Number(row.amount) || 0);
          return sum + amount;
        }, 0);
    } else if (printType === 'received') {
      // Only calculate received totals for received-only print
      totalReceived = filteredOverallData
        .filter(row => row.type === 'Received Amount')
        .reduce((sum, row) => sum + (Number(row.received_amount) || 0), 0);
    } else if (printType === 'both') {
      // Calculate both totals for combined print
      totalInvoice = filteredOverallData
        .filter(row => row.type === 'Invoice')
        .reduce((sum, row) => {
          const amount = printMode === 'overall' ? (Number(row.total_amount) || 0) : (Number(row.amount) || 0);
          return sum + amount;
        }, 0);
      
      totalReceived = filteredOverallData
        .filter(row => row.type === 'Received Amount')
        .reduce((sum, row) => sum + (Number(row.received_amount) || 0), 0);
    }

    const totalOutstanding = totalInvoice - totalReceived;

    const companyName = companyInfo?.name && companyInfo.name.length > 0 ? companyInfo.name : 'Company Name';
    const companyAddress = companyInfo?.address || 'Company Address';

    const firstLetter = companyName.charAt(0);
    const restOfName = companyName.slice(1);

    let summarySection = '';
    let footerSection = '';
    const isAllCustomers = !filters.customer_id || filters.customer_id === 'all';
    const isAllAccountHeads = !filters.account_head_id || filters.account_head_id === 'all';

    if (!isAllCustomers) {
      if (printType === 'both') {
        summarySection = `
          <div style="background:none !important; color:black !important; border:1px solid black; padding:8px; font-size:1.1rem; margin-bottom:8px; -webkit-print-color-adjust: exact; color-adjust: exact; print-color-adjust: exact;">
            Total Outstanding: ${totalBalanceAmount}
          </div>
        `;
      } else if (printType === 'received') {
        summarySection = `
          <div style="background:none !important; color:black !important; border:1px solid black; padding:8px; font-size:1.1rem; margin-bottom:8px; -webkit-print-color-adjust: exact; color-adjust: exact; print-color-adjust: exact;">
            Total Received Amount: ${totalReceived}
          </div>
        `;
      } else if (printType === 'invoice') {
        summarySection = `
          <div style="background:none !important; color:black !important; border:1px solid black; padding:8px; font-size:1.1rem; margin-bottom:8px; -webkit-print-color-adjust: exact; color-adjust: exact; print-color-adjust: exact;">
            Total Invoice Amount: ${totalInvoice}
          </div>
        `;
      }
    }

    // Determine which columns to show based on filters
    const showCustomerColumn = isAllCustomers;
    const showAccountHeadColumn = isAllAccountHeads;
    const showDateColumn = filters.from_date !== filters.to_date;
    
    // Calculate colspan for total row based on print type
    let totalColspan = 1; // S.No column
    if (showDateColumn) totalColspan += 1; // Date column
    if (showCustomerColumn) totalColspan += 1; // Customer Name column
    
    // Add Description column (always shown for all print types)
    if (printType === 'invoice' || printType === 'received' || printType === 'both') {
      totalColspan += 1; // Description column
    }
    
    // Add Account Head column (only for invoice/both types)
    if (showAccountHeadColumn && (printType === 'invoice' || printType === 'both')) {
      totalColspan += 1; // Account Head column
    }

    return `
      <style>
        @media print {
          * {
            -webkit-print-color-adjust: exact !important;
            color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .print-background {
            background: gray !important;
            color: white !important;
          }
          .received-row {
            background: #effdf4 !important;
            color: #000 !important;
          }
          .total-row {
            background: #f5f5f5 !important;
          }
        }
      </style>
      <div style="text-align:center;">
        <h1 style="margin-bottom:0;">
          <span style="color:red; font-size:2rem; font-weight:bold;">${firstLetter}</span>
          <span style="color:green; font-size:1.4rem; font-weight:bold; margin-left:-8px;">${restOfName}</span>
        </h1>
        <div style="font-size:1rem; margin-bottom:6px;">${companyAddress}</div>
        <div style="margin-bottom:6px;">Printed on ${printDate} - ${printTime}</div>
      </div>
      ${summarySection}
      <div style="display:flex; justify-content:space-between; font-weight:600; margin-bottom:8px;">
        <div>${customerName}</div>
        <div>Date ${dateRange}</div>
      </div>
      ${filters.account_head_id && filters.account_head_id !== 'all' ? `
        <div style="font-weight:600; margin-bottom:8px;">
          Account Head: ${accountHeadName}
        </div>
      ` : ''}
      <table style="width:100%; border-collapse:collapse; margin-bottom:8px;">
        <thead>
          <tr>
            <th style="border:1px solid #ccc; padding:6px;">S.No</th>
            ${showDateColumn ? `<th style="border:1px solid #ccc; padding:6px;">Date</th>` : ''}
            ${showCustomerColumn ? `<th style="border:1px solid #ccc; padding:6px;">Name</th>` : ''}
            ${(printType === 'invoice' || printType === 'received' || printType === 'both') 
              ? `<th style="border:1px solid #ccc; padding:6px;">Description</th>` 
              : ''}
            ${showAccountHeadColumn && (printType === 'invoice' || printType === 'both') ? `<th style="border:1px solid #ccc; padding:6px;">Account Head</th>` : ''}
            ${printType === 'invoice' || printType === 'both' ? `<th style="border:1px solid #ccc; padding:6px;">Invoice Amount</th>` : ''}
            ${printType === 'received' || printType === 'both' ? `<th style="border:1px solid #ccc; padding:6px;">Received Amount</th>` : ''}
          </tr>
        </thead>
        <tbody>
        ${(() => {
          let lastDate = '';
          let serialNo = 1;
          
          return filteredOverallData.map((row, idx) => {
            const isReceivedRow = Number(row.received_amount) > 0 && (!row.total_amount || Number(row.total_amount) === 0);
            const currentDate = formatDateDMY(row.date) || '-';
            const showDate = showDateColumn && currentDate !== lastDate;
            
            if (showDate) {
              lastDate = currentDate;
            }
            
            const result = `
              <tr class="${isReceivedRow ? 'received-row' : ''}" style="${isReceivedRow ? 'background:#effdf4 !important; color:#000 !important; -webkit-print-color-adjust: exact; color-adjust: exact; print-color-adjust: exact;' : ''}">
                <td style="border:1px solid #ccc; padding:6px;">${serialNo++}</td>
                ${showDateColumn ? `<td style="border:1px solid #ccc; padding:6px;">${showDate ? currentDate : ''}</td>` : ''}
                ${showCustomerColumn ? `<td style="border:1px solid #ccc; padding:6px;">${row.customer_name || '-'}</td>` : ''}
                ${(printType === 'invoice' || printType === 'received' || printType === 'both') ? `
                  <td style="border:1px solid #ccc; padding:6px;">
                    ${
                      (printType === 'invoice' || printType === 'both') && row.item_description 
                        ? row.item_description 
                        : row.received_amount_description || '-'
                    }
                  </td>
                ` : ''}
                ${showAccountHeadColumn && (printType === 'invoice' || printType === 'both') 
                  ? `<td style="border:1px solid #ccc; padding:6px;">${row.account_head || '-'}</td>` 
                  : ''}
                ${printType === 'invoice' || printType === 'both' ? `
                  <td style="border:1px solid #ccc; padding:6px;">${printMode === 'overall' ? (row.total_amount || 0) : (row.amount || 0)}</td>
                ` : ''}
                ${printType === 'received' || printType === 'both' ? `
                  <td style="border:1px solid #ccc; padding:6px;">${row.received_amount || 0}</td>
                ` : ''}
              </tr>
            `;
            
            return result;
          }).join('');
        })()}
        
        ${filteredOverallData.length > 0 ? `
          <tr class="total-row" style="font-weight:bold; background:#f5f5f5 !important; -webkit-print-color-adjust: exact; color-adjust: exact; print-color-adjust: exact;">
            <td colspan="${totalColspan}" style="text-align:right; border:1px solid #ccc; padding:6px;">Total</td>
            ${printType === 'invoice' ? `
              <td style="border:1px solid #ccc; padding:6px;">${totalInvoice}</td>
            ` : printType === 'received' ? `
              <td style="border:1px solid #ccc; padding:6px;">${totalReceived}</td>
            ` : printType === 'both' ? `
              <td style="border:1px solid #ccc; padding:6px;">${totalInvoice}</td>
              <td style="border:1px solid #ccc; padding:6px;">${totalReceived}</td>
            ` : ''}
          </tr>
        ` : ''}
        </tbody>
      </table>
      ${footerSection}
    `;
};

  const handlePrint = async() => {
    const content = await getPrintContent();
    const printWindow = window.open('', '', 'height=800,width=1100');
    if (printWindow) {
      printWindow.document.write('<html><head><title>Report Print</title>');
      printWindow.document.write(`
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          table { border-collapse: collapse; width: 100%; }
          th, td { border: 1px solid #ccc; padding: 8px; }
          th { background: #f5f5f5; }
        </style>
      `);
      printWindow.document.write('</head><body>');
      printWindow.document.write(content);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
    }
  };

  const handleGstPrint = () => {
    const now = new Date();
    const printDate = now.toLocaleDateString();
    const printTime = now.toLocaleTimeString();
    const dateRange = `From ${gstFilters.from_date} To ${gstFilters.to_date}`;
    const companyName = companyInfo?.name && companyInfo.name.length > 0 ? companyInfo.name : 'Company Name';
    const companyAddress = companyInfo?.address || 'Company Address';

    // Create styled company name with first letter larger and red
    const firstLetter = companyName.charAt(0);
    const restOfName = companyName.slice(1);

    const total_outstanding = gstData
    .reduce((sum, row) => sum + (Number(row.total_amount) || 0), 0);

    const gstTable = `
      <table style="width:100%; border-collapse:collapse; margin-bottom:8px;">
        <thead>
          <tr>
            <th style="border:1px solid #ccc; padding:6px;">S.No</th>
            <th style="border:1px solid #ccc; padding:6px;">Name (Account Head)</th>
            <th style="border:1px solid #ccc; padding:6px;">Percentage Amount</th>
            <th style="border:1px solid #ccc; padding:6px;">Total Amount</th>
          </tr>
        </thead>
        <tbody>
          ${gstData.map((row, idx) => `
            <tr>
              <td style="border:1px solid #ccc; padding:6px;">${idx + 1}</td>
              <td style="border:1px solid #ccc; padding:6px;">${row.account_head || ''}</td>
              <td style="border:1px solid #ccc; padding:6px;">${row.gst_amount || 0}</td>
              <td style="border:1px solid #ccc; padding:6px;">${row.total_amount || 0}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    `;

    const printWindow = window.open('', '', 'height=800,width=1100');
    if (printWindow) {
      printWindow.document.write('<html><head><title>GST Report Print</title>');
      printWindow.document.write(`
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          table { border-collapse: collapse; width: 100%; }
          th, td { border: 1px solid #ccc; padding: 8px; }
          th { background: #f5f5f5; }
        </style>
      `);
      printWindow.document.write('</head><body>');
      printWindow.document.write(`
        <div style="text-align:center;">
          <h1 style="margin-bottom:0;">
            <span style="color:red; font-size:2rem; font-weight:bold;">${firstLetter}</span>
            <span style="color:green; font-size:1.4rem; font-weight:bold; margin-left:-8px;">${restOfName}</span>
          </h1>
          <div style="font-size:1rem; margin-bottom:6px;">${companyAddress}</div>
          <div style="margin-bottom:6px;">Printed on ${printDate} - ${printTime}</div>
        </div>
        <div style="margin: 16px 0; font-size: 1.2rem; font-weight: 600; text-align:center;">GST Report</div>
        <div style="background:#555; color:#fff; padding:8px; font-size:1.1rem; margin-bottom:8px;">
          Total Amount: ${total_outstanding}
        </div>
        <div style="display:flex; justify-content:space-between; font-weight:600; margin-bottom:8px;">
        <div>Date ${dateRange}</div>
      </div>
        ${gstTable}
      `);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
    }
  };

  const handleEmpPrint = () => {
    const now = new Date();
    const printDate = now.toLocaleDateString();
    const printTime = now.toLocaleTimeString();
    const dateRange = `From ${employeeFilters.from_date} To ${employeeFilters.to_date}`;
    const companyName = companyInfo?.name && companyInfo.name.length > 0 ? companyInfo.name : 'Company Name';
    const companyAddress = companyInfo?.address || 'Company Address';

    // Create styled company name with first letter larger and red
    const firstLetter = companyName.charAt(0);
    const restOfName = companyName.slice(1);

    // Calculate total invoice amount for employee report
    const totalInvoice = employeeData
      .filter(row => row.type === 'Invoice')
      .reduce((sum, row) => sum + (Number(row.total_amount) || 0), 0);

    const employeeName =
      employeeFilters.employee_id && employeeFilters.employee_id !== 'all'
        ? (employeeOptions.find(e => String(e.id) === String(employeeFilters.employee_id))?.name || 'Employee')
        : 'All Employees';

    const empTable = `
      <table style="width:100%; border-collapse:collapse; margin-bottom:8px;">
        <thead>
          <tr>
            <th style="border:1px solid #ccc; padding:6px;">S.No</th>
            <th style="border:1px solid #ccc; padding:6px;">Date/Time</th>
            <th style="border:1px solid #ccc; padding:6px;">Account Head</th>
            <th style="border:1px solid #ccc; padding:6px;">Description</th>
            <th style="border:1px solid #ccc; padding:6px;">Invoice Amount</th>
            <th style="border:1px solid #ccc; padding:6px;">Employee Name</th>
          </tr>
        </thead>
        <tbody>
          ${employeeData.map((row, idx) => `
            <tr>
              <td style="border:1px solid #ccc; padding:6px;">${idx + 1}</td>
              <td style="border:1px solid #ccc; padding:6px;">${formatDateTimeDMY(row.date) || '-'}</td>
              <td style="border:1px solid #ccc; padding:6px;">${row.account_head || '-'}</td>
              <td style="border:1px solid #ccc; padding:6px;">${row.description || '-'}</td>
              <td style="border:1px solid #ccc; padding:6px;">${row.total_amount !== null ? row.total_amount : 0}</td>
              <td style="border:1px solid #ccc; padding:6px;">${row.employee_name || ''}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    `;

    const printWindow = window.open('', '', 'height=800,width=1100');
    if (printWindow) {
      printWindow.document.write('<html><head><title>Employee Report Print</title>');
      printWindow.document.write(`
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          table { border-collapse: collapse; width: 100%; }
          th, td { border: 1px solid #ccc; padding: 8px; }
          th { background: #f5f5f5; }
        </style>
      `);
      printWindow.document.write('</head><body>');
      printWindow.document.write(`
        <div style="text-align:center;">
          <h1 style="margin-bottom:0;">
            <span style="color:red; font-size:2rem; font-weight:bold;">${firstLetter}</span>
            <span style="color:green; font-size:1.4rem; font-weight:bold; margin-left:-8px;">${restOfName}</span>
          </h1>
          <div style="font-size:1rem; margin-bottom:6px;">${companyAddress}</div>
          <div style="margin-bottom:6px;">Printed on ${printDate} - ${printTime}</div>
        </div>
        <div style="margin: 16px 0; font-size: 1.2rem; font-weight: 600; text-align:center;">Employee Report</div>
        <div style="background:#555; color:#fff; padding:8px; font-size:1.1rem; margin-bottom:8px;">
          Total Amount: ${totalInvoice}
        </div>
        <div style="display:flex; justify-content:space-between; font-weight:600; margin-bottom:8px;">
          <div>${employeeName}</div>
          <div>Date ${dateRange}</div>
        </div>
        ${empTable}
      `);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
    }
  };

  const handleRevenuePrint = () => {
    const now = new Date();
    const printDate = now.toLocaleDateString();
    const printTime = now.toLocaleTimeString();
    const dateRange = `From ${revenueFilters.from_date} To ${revenueFilters.to_date}`;
    const companyName = companyInfo?.name && companyInfo.name.length > 0 ? companyInfo.name : 'Company Name';
    const companyAddress = companyInfo?.address || 'Company Address';

    // Create styled company name with first letter larger and red
    const firstLetter = companyName.charAt(0);
    const restOfName = companyName.slice(1);

    const accountHeadName =
      revenueFilters.account_head_id && revenueFilters.account_head_id !== 'all'
        ? (accountHeadOptions.find(a => String(a.id) === String(revenueFilters.account_head_id))?.name || 'Account Head')
        : 'All Account Heads';

    const revenueTable = `
      <table style="width:100%; border-collapse:collapse; margin-bottom:8px;">
        <thead>
          <tr>
            <th style="border:1px solid #ccc; padding:6px;">S.No</th>
            <th style="border:1px solid #ccc; padding:6px;">Date/Time</th>
            <th style="border:1px solid #ccc; padding:6px;">Name</th>
            <th style="border:1px solid #ccc; padding:6px;">Description</th>
            <th style="border:1px solid #ccc; padding:6px;">Service Charge</th>
          </tr>
        </thead>
        <tbody>
          ${revenueData.map((row, idx) => `
            <tr>
              <td style="border:1px solid #ccc; padding:6px;">${idx + 1}</td>
              <td style="border:1px solid #ccc; padding:6px;">${formatDateTimeDMY(row.date) || '-'}</td>
              <td style="border:1px solid #ccc; padding:6px;">${row.customer_name || '-'}</td>
              <td style="border:1px solid #ccc; padding:6px;">${row.description || '-'}</td>
              <td style="border:1px solid #ccc; padding:6px;">${row.service_charge !== null ? row.service_charge.toLocaleString() : 0}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    `;

    const printWindow = window.open('', '', 'height=800,width=1100');
    if (printWindow) {
      printWindow.document.write('<html><head><title>Revenue Report Print</title>');
      printWindow.document.write(`
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          table { border-collapse: collapse; width: 100%; }
          th, td { border: 1px solid #ccc; padding: 8px; }
          th { background: #f5f5f5; }
        </style>
      `);
      printWindow.document.write('</head><body>');
      printWindow.document.write(`
        <div style="text-align:center;">
          <h1 style="margin-bottom:0;">
            <span style="color:red; font-size:2rem; font-weight:bold;">${firstLetter}</span>
            <span style="color:green; font-size:1.4rem; font-weight:bold; margin-left:-8px;">${restOfName}</span>
          </h1>
          <div style="font-size:1rem; margin-bottom:6px;">${companyAddress}</div>
          <div style="margin-bottom:6px;">Printed on ${printDate} - ${printTime}</div>
        </div>
        <div style="margin: 16px 0; font-size: 1.2rem; font-weight: 600; text-align:center;">Revenue Report</div>
        <div style="background:#555; color:#fff; padding:8px; font-size:1.1rem; margin-bottom:8px;">
          Total Amount: ${revenueData.reduce((sum, row) => sum + (Number(row.service_charge) || 0), 0)}
        </div>
        <div style="display:flex; justify-content:space-between; font-weight:600; margin-bottom:8px;">
          <div>${accountHeadName}</div>
          <div>Date ${dateRange}</div>
        </div>
        ${revenueTable}
      `);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
    }
  };

  const filteredOverallData = overallData
    .filter(row => {
      if (filters.account_head_id && filters.account_head_id !== 'all') {
        return row.type === 'Invoice';
      }
      return true;
    })
    .filter(row => {
      if (printType === 'both') return true;
      if (printType === 'received') return row.type === 'Received Amount';
      if (printType === 'invoice') return row.type === 'Invoice';
      return true;
    });

  const visibleReports = REPORTS.filter(report => {
    if ((report.key === 'employee' || report.key === 'revenue') && auth.user?.role !== 'admin') {
      return false;
    }
    return true;
  });

  const monthOptions = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];

  const minYear = 2015;
  const currentYear = new Date().getFullYear();
  const yearOptions = [];
  for (let y = currentYear; y >= minYear; y--) {
    yearOptions.push(y);
  }

  const [selectedMonth, setSelectedMonth] = useState(String(now.getMonth() + 1).padStart(2, '0'));
  const [selectedYear, setSelectedYear] = useState(String(now.getFullYear()));

  useEffect(() => {
    const from = `${selectedYear}-${selectedMonth}-01`;
    const to = new Date(Number(selectedYear), Number(selectedMonth), 0).toLocaleDateString('en-CA');
    setGstPendingFilters(f => ({
      ...f,
      from_date: from,
      to_date: to,
    }));
  }, [selectedMonth, selectedYear]);

  const [balanceTransactions, setBalanceTransactions] = useState<BalanceTransactionRow[]>([]);
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [balanceError, setBalanceError] = useState<string | null>(null);
  const [balanceCustomerId, setBalanceCustomerId] = useState('');
  const [balanceFromDate, setBalanceFromDate] = useState(today);
  const [balanceOldBalance, setBalanceOldBalance] = useState(0);
  // const [balanceToDate, setBalanceToDate] = useState(balanceFromDate);

  const handleBalanceFilter = async () => {
    setBalanceLoading(true);
    setBalanceError(null);
    try {
      const { transactions, old_balance } = await reportService.getBalanceTransactions(balanceCustomerId, balanceFromDate, balanceFromDate);
      setBalanceTransactions(transactions);
      setBalanceOldBalance(old_balance);
    } catch {
      setBalanceError('Failed to load balance transactions');
      setBalanceTransactions([]);
      setBalanceOldBalance(0);
    } finally {
      setBalanceLoading(false);
    }
  };

  const handleBalancePrint = () => {
    const customer = customerOptions.find(c => String(c.id) === String(balanceCustomerId));
    const phone = balanceTransactions[0]?.phone || '';
    const companyName = companyInfo?.name && companyInfo.name.length > 0 ? companyInfo.name : 'Company Name';
    const companyAddress = companyInfo?.address || 'Company Address';

    // Create styled company name with first letter larger and red
    const firstLetter = companyName.charAt(0);
    const restOfName = companyName.slice(1);

    const printWindow = window.open('', '', 'height=800,width=1100');
    if (printWindow) {
      printWindow.document.write('<html><head><title>Balance Report Print</title>');
      printWindow.document.write(`
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          table { border-collapse: collapse; width: 100%; }
          th, td { border: 1px solid #ccc; padding: 8px; }
          th { background: #f5f5f5; }
          .invoice { color: #2563eb; font-weight: 600; }
          .received { color: #059669; font-weight: 600; }
        </style>
      `);
      printWindow.document.write('</head><body>');
      printWindow.document.write(`
        <div style="text-align:center;">
          <h1 style="margin-bottom:0;">
            <span style="color:red; font-size:2rem; font-weight:bold;">${firstLetter}</span>
            <span style="color:green; font-size:1.4rem; font-weight:bold; margin-left:-8px;">${restOfName}</span>
          </h1>
          <div style="font-size:1rem; margin-bottom:6px;">${companyAddress}</div>
          <h2>Balance Report</h2>
          <div style="margin-bottom:8px;">Customer: <strong>${customer?.name || ''}</strong> | Phone: <strong>${phone}</strong></div>
          <div style="margin-bottom:8px;">From: <strong>${balanceFromDate}</strong> To: <strong>${balanceFromDate}</strong></div>
        </div>
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Date/Time</th>
               <th>Type</th>
              <th>Amount</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            ${balanceTransactions.map((row, idx) => `
              <tr>
                <td>${idx + 1}</td>
                <td>${row.customer_name}</td>
                <td>${row.phone}</td>
                <td>${formatDateTimeDMY(row.date)}</td>
                <td class="${row.type}">${row.type === 'invoice' ? 'Invoice' : 'Received'}</td>
                <td class="${row.type}">${row.type === 'invoice' ? row.total_amount.toLocaleString() : row.received_amount.toLocaleString()}</td>
                <td>${row.running_balance.toLocaleString()}</td>
              </tr>
            `).join('')}
            ${balanceTransactions.length > 0 ? `
              <tr>
                <td colspan="6" style="text-align:right; font-weight:700;">Old Balance</td>
                <td style="font-weight:700;">${balanceOldBalance.toLocaleString()}</td>
              </tr>
            ` : ''}
          </tbody>
        </table>
      `);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
    }
  };

  const [sortField, setSortField] = useState<'customer_name' | 'amount' | 'service_charge' | 'total_amount' | 'total_received' | 'balance'>('customer_name');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

  const getSortIndicator = (field: string, currentField: string, direction: 'asc' | 'desc') => {
    if (field !== currentField) return '↕️';
    return direction === 'asc' ? '▲' : '▼';
  };

  const handleSort = (field: typeof sortField) => {
    if (sortField === field) {
      setSortDirection(prev => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const sortedCustomerData = [...customerData].sort((a, b) => {
    let aValue = a[sortField];
    let bValue = b[sortField];
    
    // Handle null/undefined values
    if (aValue === null || aValue === undefined) aValue = 0;
    if (bValue === null || bValue === undefined) bValue = 0;
    
    // Convert to numbers for numeric fields
    if (['amount', 'service_charge', 'total_amount', 'total_received', 'balance'].includes(sortField)) {
      aValue = Number(aValue) || 0;
      bValue = Number(bValue) || 0;
    } else {
      // For string fields, convert to lowercase for case-insensitive comparison
      aValue = String(aValue || '').toLowerCase();
      bValue = String(bValue || '').toLowerCase();
    }
    
    if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });

  const [overallSortField, setOverallSortField] = useState<'customer_name' | 'phone' | 'total_amount' | 'received_amount' | 'account_head' | 'type' | 'date'>('customer_name');
  const [overallSortDirection, setOverallSortDirection] = useState<'asc' | 'desc'>('asc');

  const handleOverallSort = (field: typeof overallSortField) => {
    if (overallSortField === field) {
      setOverallSortDirection(prev => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setOverallSortField(field);
      setOverallSortDirection('asc');
    }
  };

  const sortedOverallData = [...filteredOverallData].sort((a, b) => {
    let aValue = a[overallSortField];
    let bValue = b[overallSortField];
    
    // Handle null/undefined values
    if (aValue === null || aValue === undefined) aValue = '';
    if (bValue === null || bValue === undefined) bValue = '';
    
    // Convert to numbers for numeric fields
    if (['total_amount', 'received_amount'].includes(overallSortField)) {
      aValue = Number(aValue) || 0;
      bValue = Number(bValue) || 0;
    } else {
      // For string fields, convert to lowercase for case-insensitive comparison
      aValue = String(aValue || '').toLowerCase();
      bValue = String(bValue || '').toLowerCase();
    }
    
    if (aValue < bValue) return overallSortDirection === 'asc' ? -1 : 1;
    if (aValue > bValue) return overallSortDirection === 'asc' ? 1 : -1;
    return 0;
  });

  return (
    <div className={styles.reportsContainer}>
      <h2>Reports</h2>
      <div className={styles.tabBar}>
        {visibleReports.map((report) => (
          <button
            key={report.key}
            className={activeReport === report.key ? styles.activeTab : styles.tabBtn}
            onClick={() => setActiveReport(report.key)}
          >
            {report.label}
          </button>
        ))}
      </div>
      <div className={styles.reportContent}>
        {activeReport === 'customer' && (
          <div className={styles.reportSection}>
            <div className={styles.filterBar}>
              <div className={styles.searchWrapper}>
                <input
                  placeholder="Search by name, phone, or amount..."
                  value={customerSearch}
                  onChange={e => setCustomerSearch(e.target.value)}
                  className={styles.searchInput}
                />
                {customerSearch && (
                  <button
                    className={styles.clearBtn}
                    onClick={() => setCustomerSearch('')}
                    type="button"
                    aria-label="Clear search"
                  >
                    ×
                  </button>
                )}
                <span className={styles.searchIcon}>🔍</span>
              </div>
            </div>
            <div className={styles.tableWrapper}>
              {loading ? (
                <div>Loading...</div>
              ) : error ? (
                <div className={styles.errorMsg}>{error}</div>
              ) : (
                <table className={styles.reportTable}>
                  <thead>
                    <tr>
                      <th onClick={() => handleSort('customer_name')} style={{ cursor: 'pointer' }}>
                        Name {getSortIndicator('customer_name', sortField, sortDirection)}
                      </th>
                      <th onClick={() => handleSort('amount')} style={{ cursor: 'pointer' }}>
                        Amount {getSortIndicator('amount', sortField, sortDirection)}
                      </th>
                      <th onClick={() => handleSort('service_charge')} style={{ cursor: 'pointer' }}>
                        Service Charge {getSortIndicator('service_charge', sortField, sortDirection)}
                      </th>
                      <th onClick={() => handleSort('total_amount')} style={{ cursor: 'pointer' }}>
                        Total Amount {getSortIndicator('total_amount', sortField, sortDirection)}
                      </th>
                      <th onClick={() => handleSort('total_received')} style={{ cursor: 'pointer' }}>
                        Total Received {getSortIndicator('total_received', sortField, sortDirection)}
                      </th>
                      <th onClick={() => handleSort('balance')} style={{ cursor: 'pointer' }}>
                        Balance {getSortIndicator('balance', sortField, sortDirection)}
                      </th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedCustomerData
                      .filter(row =>
                        row.customer_name.toLowerCase().includes(customerSearch.toLowerCase()) ||
                        row.phone.toLowerCase().includes(customerSearch.toLowerCase()) ||
                        row.amount.toString().includes(customerSearch) ||
                        row.service_charge.toString().includes(customerSearch) ||
                        row.total_amount.toString().includes(customerSearch) ||
                        row.total_received.toString().includes(customerSearch)
                      )
                      .map((row) => (
                        <tr key={row.id}>
                          <td>{row.customer_name}</td>
                          <td>{row.amount.toLocaleString()}</td>
                          <td>{row.service_charge.toLocaleString()}</td>
                          <td>{row.total_amount.toLocaleString()}</td>
                          <td>{row.total_received.toLocaleString()}</td>
                          <td>{row.balance.toLocaleString()}</td>
                          <td>
                          <div className={styles.actions}>
                          <button
                          className={styles.actionButton}
                          onClick={() => navigate(`/customers/${row.id}`)}
                          title="View Customer"
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                        </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
        {activeReport === 'overall' && (
          <div className={styles.reportSection}>
            <div className={styles.filterBar}>
              <select
                className={styles.select}
                value={pendingFilters.customer_id}
                onChange={e => setPendingFilters(f => ({ ...f, customer_id: e.target.value }))}
              >
                <option value="" disabled>Select a customer</option>
                <option value="all">All Customers</option>
                {customerOptions.filter(opt => opt.id !== 'all').map(opt => (
                  <option key={opt.id} value={opt.id}>{opt.name}</option>
                ))}
              </select>
              <select
                className={styles.select}
                value={pendingFilters.account_head_id}
                onChange={e => setPendingFilters(f => ({ ...f, account_head_id: e.target.value }))}
              >
                <option value="" disabled>Select an account head</option>
                {accountHeadOptions.map(opt => (
                  <option key={opt.id} value={opt.id}>{opt.name}</option>
                ))}
              </select>
              <input
                type="date"
                value={pendingFilters.from_date}
                max={today}
                onChange={e => setPendingFilters(f => ({ ...f, from_date: e.target.value }))}
              />
              <input
                type="date"
                value={pendingFilters.to_date}
                max={today}
                onChange={e => setPendingFilters(f => ({ ...f, to_date: e.target.value }))}
              />
              <button
                className={styles.filterBtn}
                onClick={() => setFilters(pendingFilters)}
                disabled={overallLoading}
              >
                {overallLoading ? 'Filtering...' : 'Filter'}
              </button>
            </div>
            <div className={styles.printControls}>
              <select
                className={styles.select}
                value={printType}
                onChange={e => setPrintType(e.target.value as 'both' | 'received' | 'invoice')}
              >
                <option value="invoice">Invoice</option>
                <option value="received">Received</option>
                <option value="both">Both</option>
              </select>
              <label className={styles.radioLabel}>
                <input
                  type="radio"
                  name="printMode"
                  value="accountHead"
                  checked={printMode === 'accountHead'}
                  onChange={() => setPrintMode('accountHead')}
                />
                <span>Account Head Print</span>
              </label>
              <label className={styles.radioLabel}>
                <input
                  type="radio"
                  name="printMode"
                  value="overall"
                  checked={printMode === 'overall'}
                  onChange={() => setPrintMode('overall')}
                />
                <span>Overall Print</span>
              </label>
              <InactiveCompanyActionRestriction actionName="Printing">
                <button
                  className={styles.printBtn}
                  onClick={handlePrint}
                  type="button"
                >
                  Print
                </button>
              </InactiveCompanyActionRestriction>
            </div>
            <div className={styles.tableWrapper}>
              {overallLoading ? (
                <div>Loading...</div>
              ) : overallError ? (
                <div className={styles.errorMsg}>{overallError}</div>
              ) : (
                <table className={styles.reportTable} id="overallReportTable">
                  <thead>
                    <tr>
                      <th onClick={() => handleOverallSort('customer_name')} style={{ cursor: 'pointer' }}>
                        Name {getSortIndicator('customer_name', overallSortField, overallSortDirection)}
                      </th>
                      <th onClick={() => handleOverallSort('phone')} style={{ cursor: 'pointer' }}>
                        Phone {getSortIndicator('phone', overallSortField, overallSortDirection)}
                      </th>
                      <th onClick={() => handleOverallSort('total_amount')} style={{ cursor: 'pointer' }}>
                        Total Amount {getSortIndicator('total_amount', overallSortField, overallSortDirection)}
                      </th>
                      <th onClick={() => handleOverallSort('received_amount')} style={{ cursor: 'pointer' }}>
                        Received Amount {getSortIndicator('received_amount', overallSortField, overallSortDirection)}
                      </th>
                      <th onClick={() => handleOverallSort('account_head')} style={{ cursor: 'pointer' }}>
                        Account Head {getSortIndicator('account_head', overallSortField, overallSortDirection)}
                      </th>
                      <th onClick={() => handleOverallSort('type')} style={{ cursor: 'pointer' }}>
                        Type {getSortIndicator('type', overallSortField, overallSortDirection)}
                      </th>
                      <th onClick={() => handleOverallSort('date')} style={{ cursor: 'pointer' }}>
                        Date {getSortIndicator('date', overallSortField, overallSortDirection)}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedOverallData.length === 0 ? (
                      <tr>
                        <td colSpan={8} style={{ textAlign: 'center', color: '#888' }}>
                          No data found
                        </td>
                      </tr>
                    ) : (
                      sortedOverallData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.customer_name}</td>
                          <td>{row.phone}</td>
                          <td>{row.total_amount !== null ? row.total_amount.toLocaleString() : ''}</td>
                          <td>{row.received_amount !== null ? row.received_amount.toLocaleString() : ''}</td>
                          <td>{row.account_head || ''}</td>
                          <td>{row.type}</td>
                          <td>{formatDateTimeDMY(row.date) || '-'}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
        {activeReport === 'gst' && (
          <div className={styles.reportSection}>
            <div className={styles.filterBar}>
              <select
                className={styles.select}
                value={gstPendingFilters.account_head_id}
                onChange={e => setGstPendingFilters(f => ({ ...f, account_head_id: e.target.value }))}
              >
                <option value="" disabled>Select an account head</option>
                <option value="all">All Account Heads</option>
                {accountHeadOptions.filter(opt => opt.id !== 'all').map(opt => (
                  <option key={opt.id} value={opt.id}>{opt.name}</option>
                ))}
              </select>
              <select
                className={styles.select}
                value={selectedMonth}
                onChange={e => setSelectedMonth(e.target.value)}
              >
                {monthOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
              <select
                className={styles.select}
                value={selectedYear}
                onChange={e => setSelectedYear(e.target.value)}
              >
                {yearOptions.map(y => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
              <button
                className={styles.filterBtn}
                onClick={() => setGstFilters(gstPendingFilters)}
                disabled={gstLoading}
              >
                {gstLoading ? 'Filtering...' : 'Filter'}
              </button>
            </div>
            <div className={styles.printControls}>
              <InactiveCompanyActionRestriction actionName="Printing">
                <button
                  className={styles.printBtn}
                  onClick={handleGstPrint}
                  type="button"
                >
                  Print
                </button>
              </InactiveCompanyActionRestriction>
            </div>
            <div className={styles.tableWrapper}>
              {gstLoading ? (
                <div>Loading...</div>
              ) : gstError ? (
                <div className={styles.errorMsg}>{gstError}</div>
              ) : (
                <table className={styles.reportTable}>
                  <thead>
                    <tr>
                      <th>Account Head</th>
                      <th>Total Amount</th>
                      <th>Percentage Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gstData.length === 0 ? (
                      <tr>
                        <td colSpan={3} style={{ textAlign: 'center', color: '#888' }}>
                          No data found
                        </td>
                      </tr>
                    ) : (
                      gstData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.account_head}</td>
                          <td>{row.total_amount.toLocaleString()}</td>
                          <td>{row.gst_amount.toLocaleString()}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
        {activeReport === 'employee' && auth.user?.role === 'admin' && (
          <div className={styles.reportSection}>
            <div className={styles.filterBar}>
              <select
                className={styles.select}
                value={pendingEmployeeFilters.employee_id}
                onChange={e => setPendingEmployeeFilters(f => ({ ...f, employee_id: e.target.value }))}
              >
                <option value="" disabled>Select an employee</option>
                <option value="all">All Employees</option>
                {employeeOptions.filter(opt => opt.id !== 'all').map(opt => (
                  <option key={opt.id} value={opt.id}>{opt.name}</option>
                ))}
              </select>
              <input
                type="date"
                value={pendingEmployeeFilters.from_date}
                max={today}
                onChange={e => setPendingEmployeeFilters(f => ({ ...f, from_date: e.target.value }))}
              />
              <input
                type="date"
                value={pendingEmployeeFilters.to_date}
                max={today}
                onChange={e => setPendingEmployeeFilters(f => ({ ...f, to_date: e.target.value }))}
              />
              <button
                className={styles.filterBtn}
                onClick={() => setEmployeeFilters(pendingEmployeeFilters)}
                disabled={employeeLoading}
              >
                {employeeLoading ? 'Filtering...' : 'Filter'}
              </button>
            </div>
            <div className={styles.printControls}>
              <InactiveCompanyActionRestriction actionName="Printing">
                <button
                  className={styles.printBtn}
                  onClick={handleEmpPrint}
                  type="button"
                >
                  Print
                </button>
              </InactiveCompanyActionRestriction>
            </div>
            <div className={styles.tableWrapper}>
              {employeeLoading ? (
                <div>Loading...</div>
              ) : employeeError ? (
                <div className={styles.errorMsg}>{employeeError}</div>
              ) : (
                <table className={styles.reportTable}>
                  <thead>
                    <tr>
                      <th>Customer Name</th>
                      <th>Phone</th>
                      <th>Description</th>
                      <th>Invoice Amount</th>
                      <th>Account Head</th>
                      <th>Type</th>
                      <th>Employee Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {employeeData.length === 0 ? (
                      <tr>
                        <td colSpan={6} style={{ textAlign: 'center', color: '#888' }}>
                          No data found
                        </td>
                      </tr>
                    ) : (
                      employeeData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.customer_name}</td>
                          <td>{row.phone_number}</td>
                          <td>{row.description}</td>
                          <td>{row.total_amount !== null ? row.total_amount.toLocaleString() : '-'}</td>
                          <td>{row.account_head || '-'}</td>
                          <td>{row.type}</td>
                          <td>{row.employee_name || '-'}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
        {activeReport === 'revenue' && auth.user?.role === 'admin' && (
          <div className={styles.reportSection}>
            <div className={styles.filterBar}>
              <select
                className={styles.select}
                value={pendingRevenueFilters.account_head_id}
                onChange={e => setPendingRevenueFilters(f => ({ ...f, account_head_id: e.target.value }))}
              >
                <option value="" disabled>Select an account head</option>
                {accountHeadOptions.map(opt => (
                  <option key={opt.id} value={opt.id}>{opt.name}</option>
                ))}
              </select>
              <input
                type="date"
                value={pendingRevenueFilters.from_date}
                max={today}
                onChange={e => setPendingRevenueFilters(f => ({ ...f, from_date: e.target.value }))}
              />
              <input
                type="date"
                value={pendingRevenueFilters.to_date}
                max={today}
                onChange={e => setPendingRevenueFilters(f => ({ ...f, to_date: e.target.value }))}
              />
              <button
                className={styles.filterBtn}
                onClick={() => setRevenueFilters(pendingRevenueFilters)}
                disabled={revenueLoading}
              >
                {revenueLoading ? 'Filtering...' : 'Filter'}
              </button>
            </div>
            <div className={styles.printControls}>
              <InactiveCompanyActionRestriction actionName="Printing">
                <button
                  className={styles.printBtn}
                  onClick={handleRevenuePrint}
                  type="button"
                >
                  Print
                </button>
              </InactiveCompanyActionRestriction>
            </div>
            <div className={styles.tableWrapper}>
              {revenueLoading ? (
                <div>Loading...</div>
              ) : revenueError ? (
                <div className={styles.errorMsg}>{revenueError}</div>
              ) : (
                <table className={styles.reportTable}>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>Description</th>
                      <th>Total Amount</th>
                      <th>Account Head</th>
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {revenueData.length === 0 ? (
                      <tr>
                        <td colSpan={6} style={{ textAlign: 'center', color: '#888' }}>
                          No data found
                        </td>
                      </tr>
                    ) : (
                      revenueData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.customer_name}</td>
                          <td>{row.phone_number}</td>
                          <td>{row.description}</td>
                          <td>{row.total_amount.toLocaleString()}</td>
                          <td>{row.account_head}</td>
                          <td>{row.type}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
        {activeReport === 'balance' && (
          <div className={styles.reportSection}>
            <div className={styles.filterBar}>
              <select
                className={styles.select}
                value={balanceCustomerId}
                onChange={e => setBalanceCustomerId(e.target.value)}
              >
                <option value="" disabled>Select a customer</option>
                {customerOptions.filter(opt => opt.id !== 'all').map(opt => (
                  <option key={opt.id} value={opt.id}>{opt.name}</option>
                ))}
              </select>
              <input
                type="date"
                value={balanceFromDate}
                max={today}
                onChange={e => setBalanceFromDate(e.target.value)}
              />
              {/* <input
                type="date"
                value={balanceToDate}
                max={today}
                onChange={e => setBalanceToDate(e.target.value)}
              /> */}
              <button
                className={styles.filterBtn}
                onClick={handleBalanceFilter}
                disabled={balanceLoading || !balanceCustomerId}
              >
                {balanceLoading ? 'Filtering...' : 'Filter'}
              </button>
              <InactiveCompanyActionRestriction actionName="Printing">
                <button
                  className={styles.printBtn}
                  onClick={handleBalancePrint}
                  type="button"
                  disabled={balanceTransactions.length === 0}
                >
                  Print
                </button>
              </InactiveCompanyActionRestriction>
            </div>
            <div className={styles.tableWrapper}>
              {balanceLoading ? (
                <div>Loading...</div>
              ) : balanceError ? (
                <div className={styles.errorMsg}>{balanceError}</div>
              ) : (
                <table className={styles.reportTable}>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      {/* <th>Phone</th> */}
                      {/* <th>Date/Time</th> */}
                      <th>Type</th>
                      <th>Amount</th>
                      <th>Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {balanceTransactions.length === 0 ? (
                      <tr>
                        <td colSpan={7} style={{ textAlign: 'center', color: '#888' }}>
                          No data found
                        </td>
                      </tr>
                    ) : (
                      balanceTransactions.map((row, idx) => (
                        <tr key={row.id + row.date + row.type}>
                          <td>{idx + 1}</td>
                          <td>{row.customer_name}</td>
                          {/* <td>{row.phone}</td> */}
                          {/* <td>{formatDateTime(row.date)}</td> */}
                          <td>
                            <span style={{ color: row.type === 'invoice' ? '#2563eb' : '#059669' }}>
                              {row.type === 'invoice' ? 'Invoice' : 'Received'}
                            </span>
                          </td>
                          <td>
                            {row.type === 'invoice' ? (
                              <span style={{ color: '#2563eb', fontWeight: 600 }}>{row.total_amount.toLocaleString()}</span>
                            ) : (
                              <span style={{ color: '#059669', fontWeight: 600 }}>{row.received_amount.toLocaleString()}</span>
                            )}
                          </td>
                          <td>{row.running_balance.toLocaleString()}</td>
                        </tr>
                      ))
                    )}
                    {balanceTransactions.length > 0 && (
                      <tr>
                        <td colSpan={4} style={{ textAlign: 'right', fontWeight: 700 }}>Old Balance</td>
                        <td style={{ fontWeight: 700 }}>{balanceOldBalance.toLocaleString()}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportsPage; 
